import { TranslationType } from '../components/HbtPortfolioManagementTable/types';

export const statusMapping = (t: TranslationType) => {
  const mapping = {
    '01': t('Pi-Portfolio-Management-Table-Status-Mapping-R', 'Received'),
    '02': t('Pi-Portfolio-Management-Table-Status-Mapping-VIP', 'Validation in progress'),
    '03': t('Pi-Portfolio-Management-Table-Status-Mapping-VC', 'Validation completed'),
    '04': t('Pi-Portfolio-Management-Table-Status-Mapping-RFCB', 'Ready for Credit Bureau'),
    '05': t('Pi-Portfolio-Management-Table-Status-Mapping-FRCB', 'File ready for Credit Bureau'),
    '06': t('Pi-Portfolio-Management-Table-Status-Mapping-STCB', 'Sent to Credit Bureau'),
    '07': t('Pi-Portfolio-Management-Table-Status-Mapping-REFCB', 'Received from Credit Bureau'),
    '08': t('Pi-Portfolio-Management-Table-Status-Mapping-STMPI', 'Sent to Master Pool Inventory'),
    '09': t('Pi-Portfolio-Management-Table-Status-Mapping-D', 'Deleted'),
    '10': t('Pi-Portfolio-Management-Table-Status-Mapping-M', 'Manual'),
    '11': t('Pi-Portfolio-Management-Table-Status-Mapping-RTC', 'Ready to cancel'),
    '12': t('Pi-Portfolio-Management-Table-Status-Mapping-CC', 'Cancellation completed')
  };
  return mapping;
};
